import Crud from '../views/StockMovement/Crud'
import Entity from '../views/StockMovement/Add'
import View from '../views/StockMovement/View'

let routes = {
    path: '/stock_movements',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/stock_movements/add',
            name: 'NewStockMovement',
            component: Entity,
            meta: {
                pageTitle: 'Movimentação',
                breadcrumb: [
                    { text: 'Movimentação', active: false, to: '/stock_movements' },
                    { text: 'Nova Movimentação', active: true }
                ],
            },
        },
        {
            path: '/stock_movements',
            name: 'list-stock-movements',
            component: Crud,
            meta: {
                pageTitle: '',
                breadcrumb: [
                    { text: 'Movimentação', active: true },
                ],
            },
        },
        {
            path: '/stock_movements/view/:id',
            name: 'ViewStockMovement',
            component: View,
            meta: {
                pageTitle: 'Movimentação',
                breadcrumb: [
                    { text: 'Movimentação', active: false, to: '/stock_movements' },
                    { text: 'Visualizar', active: true }
                ],
            },
        },
    ]
};

export default routes
